import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Buttons_instancevdnfm4kr7aly as Buttons_instance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
  ProjectLens_Preview_getInstance1ljkez32qkuib as ProjectLens_Preview_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
} from '../../screens/common/ProjectView.mjs';
import {
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  WarningButtonSemantice48d7oqt0xse as WarningButtonSemantic,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import {
  ButtonActionqmmxsu493eh2 as ButtonAction,
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
  ButtonFormatting3voagp9s33g1x as ButtonFormatting,
} from '../../../utils/ButtonAction.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  ProjectState_Locked_getInstance2lzy284wfpx83 as ProjectState_Locked_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
  PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je as PaymentState_AwaitingConfirmation_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  AffirmativeSemantic_getInstance3qy0l8mucaq7h as AffirmativeSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  EmailAddressWithName1kgo9tfobddjb as EmailAddressWithName,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c as _MonetaryValue___get_absoluteValue__impl__hjldkw,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { maybeSafariOrIos3eb7nhtdbwd99 as maybeSafariOrIos } from '../../../actuals/iosCheck.js.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { get_darkSection25mxxvxk8ts3b as get_darkSection } from '../../theming/sections.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  Action1a4ymn5nx79hk as Action,
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
} from '../../../utils/utils.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
} from '../nav/crowpay.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { IssueButton_getInstance2eudvtxrfqyy3 as IssueButton_getInstance } from '../../theming/formThemes.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
} from '../../dialogs/GenericConfirmationDialog.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { EditProject1iovryfu514gb as EditProject } from '../../screens/contractor/EditProject.mjs';
import { toEmailAddress2ffkb20dbp5nk as toEmailAddress } from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  assertValidEmail3vrj63qp73iex as assertValidEmail,
  validategsg6go7eyi9d as validate,
} from '../../../utils/validation.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  dialog2nk0sz8wudj8p as dialog,
  toast3qlkoaxwmk6x7 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { RequestFinalCompletionDialog3h3fcreklk22e as RequestFinalCompletionDialog } from '../../dialogs/RequestSignOffDialog.mjs';
import { ProjectCompleteRequestDetails1r4j7qa671vek as ProjectCompleteRequestDetails } from '../../dialogs/BasicFlowForms.mjs';
import { ClientPaymentInfo323a5wacn9ntp as ClientPaymentInfo } from '../../screens/client/ClientProject.mjs';
import { CollectFundsThroughPhysicalCheckDialog3f44xr2mvj2de as CollectFundsThroughPhysicalCheckDialog } from '../../dialogs/CollectFunds.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  PayUnrequested_getInstance3elwvp0p6ot2o as PayUnrequested_getInstance,
  PayRequested65fjypdtje6w as PayRequested,
  MakePaymentInfoBandaidDialog18vq2rlet73fk as MakePaymentInfoBandaidDialog,
  PayRemainingToCompleteProject_getInstance86isfd7phkqn as PayRemainingToCompleteProject_getInstance,
} from '../../dialogs/MakePaymentDialog.mjs';
import { UploadSettlementDocsDialog3j42xvchj1p9v as UploadSettlementDocsDialog } from './settlements/UploadSettlementDocsDialog.mjs';
import { setClipboardText197l45mq3981x as setClipboardText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  ProjectUnlockProposalDialogftazpb7o94qs as ProjectUnlockProposalDialog,
  viewUnlockProposalDialog1s7xyjel5pmhj as viewUnlockProposalDialog,
} from './settlements/unlockProjectDialogs.mjs';
import { requestFundsDialog11j6g5n16g4u9 as requestFundsDialog } from '../../dialogs/requestFunds.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { hash2t85n3abss7t0 as hash } from '../../../../../../crowpay-shared/com/crowpay/extensions/Project.ext.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_state3dimnrbngbj36 as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { FileIncidentConfirmation1hq6dfo832450 as FileIncidentConfirmation } from '../../dialogs/FileIncidentConfirmation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar2(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var $this$with = writer;
  var firstAction = _this__u8e3s4.ugj('firstAction', () => remember(VOID, VOID, VOID, ($this$remember) => {
    var project = $this$remember.daj(_this__u8e3s4.lfy());
    var tmp;
    if ($this$remember.daj(_this__u8e3s4.ugi_1)) {
      var tmp_0 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Cancel Project', tmp_0, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_0(_this__u8e3s4, $this$remember, project));
    } else if ($this$remember.daj(_this__u8e3s4.tgi_1)) {
      var tmp_1 = actionBar2$_anonymous_$suffixIfWide_swc2ex('Abandon', $this$with, 'Project');
      var tmp_2 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1(tmp_1, tmp_2, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_2($this$remember, project, $this$with));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(_this__u8e3s4.ngi_1)) {
      tmp = raiseIssueAtFinalCompletion(Buttons_instance, project, _this__u8e3s4.tgj());
    } else {
      tmp = null;
    }
    return tmp;
  }));
  var secondAction = _this__u8e3s4.ugj('secondAction', () => remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.daj(_this__u8e3s4.tgi_1)) {
      var tmp_0 = DangerButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Unpublish', tmp_0, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_4(_this__u8e3s4, $this$remember, $this$with));
    } else {
      tmp = null;
    }
    return tmp;
  }));
  var thirdAction = _this__u8e3s4.ugj('thirdAction', () => remember(VOID, VOID, VOID, ($this$remember) => {
    var project = $this$remember.daj(_this__u8e3s4.lfy());
    var tmp;
    if (_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance()) && $this$remember.daj(_this__u8e3s4.tgi_1)) {
      var tmp_0 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Email Link', tmp_0, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_6($this$with, _this__u8e3s4, $this$remember));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance()) && $this$remember.daj(_this__u8e3s4.mgi_1)) {
      var tmp_1 = PrimaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Request Final Completion', tmp_1, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_8(_this__u8e3s4));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(_this__u8e3s4.ngi_1)) {
      var tmp_2 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Review Request', tmp_2, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_10($this$with, project, _this__u8e3s4));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(_this__u8e3s4.qgi_1) && MonetaryValue__compareTo_impl_w7ul1r($this$remember.daj(_this__u8e3s4.rgi_1).y5r_1, Companion_instance.r91(0n)) > 0) {
      tmp = ButtonAction().fg1('Collect Credit', VOID, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_12(_this__u8e3s4, $this$remember));
    } else if ($this$remember.daj(_this__u8e3s4.sgi_1)) {
      var tmp_3 = WarningButtonSemantic();
      tmp = ButtonAction().fg1('Rescind Funds Request', tmp_3, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_14($this$with, $this$remember, _this__u8e3s4));
    } else if ($this$remember.daj(_this__u8e3s4.ogi_1) && $this$remember.daj(_this__u8e3s4.cgj_1).d4(ProjectState_AwaitingFunding_getInstance()) >= 0) {
      tmp = ButtonAction().fg1('Send Escrow Funds', VOID, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_16(project, _this__u8e3s4));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Preview_getInstance())) {
      var tmp_4 = ButtonSemantic_getInstance().abf(AffirmativeSemantic_getInstance());
      tmp = ButtonAction().fg1('Accept Project', tmp_4, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_18(_this__u8e3s4, $this$with));
    } else if (project.u7b_1.equals(ProjectState_Locked_getInstance())) {
      var tmp_5 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('Settle', tmp_5, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_20(project, _this__u8e3s4));
    } else {
      tmp = null;
    }
    return tmp;
  }));
  var fourthAction = _this__u8e3s4.ugj('fourthAction', () => remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.daj(_this__u8e3s4.tgi_1)) {
      var link = rememberSuspending(VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_22($this$remember, _this__u8e3s4));
      var tmp_0;
      if (maybeSafariOrIos()) {
        tmp_0 = ($this$ButtonAction) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$ButtonAction.faj(link);
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
          return !(tmp instanceof InternalReactiveNotReady());
        };
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      tmp = ButtonAction().fg1('Copy Link', VOID, VOID, VOID, VOID, tmp_1, actionBar2$lambda$lambda$slambda_24($this$with, link));
    } else if ($this$remember.daj(_this__u8e3s4.cgj_1).equals(ProjectState_Locked_getInstance())) {
      var mostRecentRequest = $this$remember.daj(_this__u8e3s4.wgj());
      var tmp_2;
      if (mostRecentRequest == null) {
        tmp_2 = ButtonAction().fg1('Unlock Project', VOID, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_26(_this__u8e3s4));
      } else {
        var submittedByMe = mostRecentRequest.n86_1 === _this__u8e3s4.tgj().zgj();
        var tmp_3 = !submittedByMe ? 'Review Unlock Request' : 'View Unlock Request';
        tmp_2 = ButtonAction().fg1(tmp_3, VOID, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_28(_this__u8e3s4, $this$with, mostRecentRequest, submittedByMe));
      }
      tmp = tmp_2;
    } else if ($this$remember.daj(_this__u8e3s4.pgi_1)) {
      var tmp_4 = ($this$ButtonAction) => $this$ButtonAction.daj(_this__u8e3s4.vgj()).i1() ? 'Request Funds' : 'Request More Funds';
      tmp = ButtonAction().fg1('Request Funds', VOID, tmp_4, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_30(_this__u8e3s4, $this$remember));
    } else if (_this__u8e3s4.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(_this__u8e3s4.ngi_1)) {
      tmp = acceptFinalCompletion(Buttons_instance, _this__u8e3s4, $this$with);
    } else if ($this$remember.daj(_this__u8e3s4.cgj_1).equals(ProjectState_Complete_getInstance())) {
      var tmp_5 = SecondaryButtonSemantic_getInstance();
      tmp = ButtonAction().fg1('View Final Completion', tmp_5, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda_32(_this__u8e3s4, $this$with));
    } else {
      tmp = null;
    }
    return tmp;
  }));
  var numActions = remember(VOID, VOID, VOID, ($this$remember) => listOfNotNull([$this$remember.daj(firstAction), $this$remember.daj(secondAction), $this$remember.daj(thirdAction), $this$remember.daj(fourthAction)]).p1());
  var tmp = $this$with.kbb(shownWhen($this$with, VOID, ($this$shownWhen) => $this$shownWhen.daj(numActions) > 0), get_darkSection($this$with));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this$with.pc());
  var tmp0_elvis_lhs = $this$with.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$with : tmp0_elvis_lhs;
  $this$with.gbb(p, view);
  var $this$frame = view;
  reactive($this$frame, ($this$reactive) => {
    $this$frame.bba();
    var tmp;
    if (get_viewIsNarrow($this$frame) && $this$reactive.daj(numActions) > 3) {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = $this$frame;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())(this_0.pc());
      var tmp0_elvis_lhs = this_0.ebb_1;
      var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
      this_0.gbb(p, view);
      view.zbm(true);
      view.bb9(get_AppDimensions().kg2_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      view_0.zbm(false);
      view_0.bb9(get_AppDimensions().kg2_1);
      var tmp_0 = get_expanding(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      applyReactiveActionFormatting(view_1, firstAction, false);
      view_0.hbb(p_1, view_1);
      view_0.lbb(tmp_0, view_1);
      var tmp_1 = get_expanding(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.gbb(p_2, view_2);
      applyReactiveActionFormatting(view_2, secondAction, false);
      view_0.hbb(p_2, view_2);
      view_0.lbb(tmp_1, view_2);
      view.hbb(p_0, view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_3 = view.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
      view.gbb(p_3, view_3);
      view_3.zbm(false);
      view_3.bb9(get_AppDimensions().kg2_1);
      var tmp_2 = get_expanding(view_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_4 = view_3.ebb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
      view_3.gbb(p_4, view_4);
      applyReactiveActionFormatting(view_4, thirdAction, false);
      view_3.hbb(p_4, view_4);
      view_3.lbb(tmp_2, view_4);
      var tmp_3 = get_expanding(view_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_5 = view_3.ebb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
      view_3.gbb(p_5, view_5);
      applyReactiveActionFormatting(view_5, fourthAction, false);
      view_3.hbb(p_5, view_5);
      view_3.lbb(tmp_3, view_5);
      view.hbb(p_3, view_3);
      this_0.hbb(p, view);
      tmp = view;
    } else if (get_viewIsNarrow($this$frame) && $this$reactive.daj(numActions) > 1) {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_1 = $this$frame;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (RowOrCol())(this_1.pc());
      var tmp0_elvis_lhs_6 = this_1.ebb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? this_1 : tmp0_elvis_lhs_6;
      this_1.gbb(p_6, view_6);
      view_6.zbm(false);
      view_6.bb9(get_AppDimensions().kg2_1);
      var tmp_4 = get_expanding(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_7 = new (Button())(view_6.pc());
      var tmp0_elvis_lhs_7 = view_6.ebb_1;
      var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
      view_6.gbb(p_7, view_7);
      applyReactiveActionFormatting(view_7, firstAction, false);
      view_6.hbb(p_7, view_7);
      view_6.lbb(tmp_4, view_7);
      var tmp_5 = get_expanding(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (Button())(view_6.pc());
      var tmp0_elvis_lhs_8 = view_6.ebb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
      view_6.gbb(p_8, view_8);
      applyReactiveActionFormatting(view_8, secondAction, false);
      view_6.hbb(p_8, view_8);
      view_6.lbb(tmp_5, view_8);
      var tmp_6 = get_expanding(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (Button())(view_6.pc());
      var tmp0_elvis_lhs_9 = view_6.ebb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
      view_6.gbb(p_9, view_9);
      applyReactiveActionFormatting(view_9, thirdAction, false);
      view_6.hbb(p_9, view_9);
      view_6.lbb(tmp_6, view_9);
      var tmp_7 = get_expanding(view_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_10 = new (Button())(view_6.pc());
      var tmp0_elvis_lhs_10 = view_6.ebb_1;
      var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
      view_6.gbb(p_10, view_10);
      applyReactiveActionFormatting(view_10, fourthAction, false);
      view_6.hbb(p_10, view_10);
      view_6.lbb(tmp_7, view_10);
      this_1.hbb(p_6, view_6);
      tmp = view_6;
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_2 = $this$frame;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_11 = new (RowOrCol())(this_2.pc());
      var tmp0_elvis_lhs_11 = this_2.ebb_1;
      var p_11 = tmp0_elvis_lhs_11 == null ? this_2 : tmp0_elvis_lhs_11;
      this_2.gbb(p_11, view_11);
      view_11.zbm(false);
      view_11.bb9(get_AppDimensions().kg2_1);
      var tmp_8 = get_centered(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_12 = new (Button())(view_11.pc());
      var tmp0_elvis_lhs_12 = view_11.ebb_1;
      var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
      view_11.gbb(p_12, view_12);
      applyReactiveActionFormatting(view_12, firstAction);
      view_11.hbb(p_12, view_12);
      view_11.lbb(tmp_8, view_12);
      var tmp_9 = get_centered(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_13 = new (Button())(view_11.pc());
      var tmp0_elvis_lhs_13 = view_11.ebb_1;
      var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
      view_11.gbb(p_13, view_13);
      applyReactiveActionFormatting(view_13, secondAction);
      view_11.hbb(p_13, view_13);
      view_11.lbb(tmp_9, view_13);
      if (_this__u8e3s4.tgj().equals(ProjectLens_Preview_getInstance())) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Frame())(view_11.pc());
        var tmp0_elvis_lhs_14 = view_11.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_11 : tmp0_elvis_lhs_14;
        view_11.gbb(p_14, view_14);
        var tmp_10 = get_centered(view_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_14.pc());
        var tmp0_elvis_lhs_15 = view_14.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
        view_14.gbb(p_15, view_15);
        view_15.zbm(false);
        shownDefaultFalse(view_15, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(_this__u8e3s4.ggi_1));
        view_15.fba(get_AppDimensions().lg2_1);
        var tmp_11 = get_primaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        specCenteredText(view_16, 'Register');
        view_16.obg(Action('Register', VOID, actionBar2$lambda$slambda_0(_this__u8e3s4, view_16)));
        view_15.hbb(p_16, view_16);
        view_15.lbb(tmp_11, view_16);
        var tmp_12 = get_secondaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_17 = view_15.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
        view_15.gbb(p_17, view_17);
        specCenteredText(view_17, 'Log In');
        view_17.obg(Action('Log In', VOID, actionBar2$lambda$slambda_2(_this__u8e3s4, view_17)));
        view_15.hbb(p_17, view_17);
        view_15.lbb(tmp_12, view_17);
        view_14.hbb(p_15, view_15);
        view_14.lbb(tmp_10, view_15);
        view_11.hbb(p_14, view_14);
      }
      var tmp_13 = get_expanding(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_18 = new (Space())(view_11.pc());
      var tmp0_elvis_lhs_18 = view_11.ebb_1;
      var p_18 = tmp0_elvis_lhs_18 == null ? view_11 : tmp0_elvis_lhs_18;
      view_11.gbb(p_18, view_18);
      view_11.hbb(p_18, view_18);
      view_11.lbb(tmp_13, view_18);
      var tmp_14 = get_centered(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_19 = new (Button())(view_11.pc());
      var tmp0_elvis_lhs_19 = view_11.ebb_1;
      var p_19 = tmp0_elvis_lhs_19 == null ? view_11 : tmp0_elvis_lhs_19;
      view_11.gbb(p_19, view_19);
      applyReactiveActionFormatting(view_19, thirdAction);
      view_11.hbb(p_19, view_19);
      view_11.lbb(tmp_14, view_19);
      var tmp_15 = get_centered(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_20 = new (Button())(view_11.pc());
      var tmp0_elvis_lhs_20 = view_11.ebb_1;
      var p_20 = tmp0_elvis_lhs_20 == null ? view_11 : tmp0_elvis_lhs_20;
      view_11.gbb(p_20, view_20);
      applyReactiveActionFormatting(view_20, fourthAction);
      view_11.hbb(p_20, view_20);
      view_11.lbb(tmp_15, view_20);
      this_2.hbb(p_11, view_11);
      tmp = view_11;
    }
    return tmp;
  });
  $this$with.hbb(p, view);
  return $this$with.lbb(tmp, view);
}
function acceptFinalCompletion(_this__u8e3s4, projectData, writer) {
  // Inline function 'kotlin.with' call
  return ButtonAction().fg1('Accept & Pay Retention', VOID, VOID, VOID, VOID, VOID, acceptFinalCompletion$slambda_0(projectData, writer));
}
function raiseIssueAtFinalCompletion(_this__u8e3s4, project, lens) {
  var tmp = IssueButton_getInstance();
  return ButtonAction().fg1('Raise Issue', tmp, VOID, VOID, VOID, VOID, raiseIssueAtFinalCompletion$slambda_0(project, lens));
}
function actionBar2$_anonymous_$suffixIfWide_swc2ex(_this__u8e3s4, $this_with, suffix) {
  return get_viewIsNarrow($this_with) ? _this__u8e3s4 : _this__u8e3s4 + ' ' + suffix;
}
function *_generator_invoke__zhh2q8($this, confirmed, $completion) {
  if (confirmed) {
    var session = $this.agk_1.daj(get_session());
    var tmp = session.vfw().rfg_1.afp($this.bgk_1.v7a_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, confirmed, $completion) {
  if (confirmed) {
    var session = $this.cgk_1.daj(get_session());
    var tmp = session.vfw().rfg_1.afp($this.dgk_1.v7a_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambda$slambdaClass;
function actionBar2$lambda$lambda$slambda$slambda() {
  if (actionBar2$lambda$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_remember, $project) {
        this.agk_1 = $this_remember;
        this.bgk_1 = $project;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambda$slambdaClass = $;
  }
  return actionBar2$lambda$lambda$slambda$slambdaClass;
}
function actionBar2$lambda$lambda$slambda$slambda_0($this_remember, $project) {
  var i = new (actionBar2$lambda$lambda$slambda$slambda())($this_remember, $project);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambda$slambdaClass_0;
function actionBar2$lambda$lambda$slambda$slambda_1() {
  if (actionBar2$lambda$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_remember, $project) {
        this.cgk_1 = $this_remember;
        this.dgk_1 = $project;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambda$slambdaClass_0 = $;
  }
  return actionBar2$lambda$lambda$slambda$slambdaClass_0;
}
function actionBar2$lambda$lambda$slambda$slambda_2($this_remember, $project) {
  var i = new (actionBar2$lambda$lambda$slambda$slambda_1())($this_remember, $project);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass;
function actionBar2$lambda$lambda$slambda() {
  if (actionBar2$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($this_actionBar2, $this_remember, $project) {
        this.fgk_1 = $this_actionBar2;
        this.ggk_1 = $this_remember;
        this.hgk_1 = $project;
      }
      yah($this$ButtonAction, $completion) {
        switch (this.fgk_1.tgj().b4_1) {
          case 0:
            var mainMessage = 'Canceling a project often offends clients and may result in a bad review. If canceling is absolutely necessary you should communicate and notify client directly prior to clicking "Cancel Project" button.';
            var tmp = get_dialogStack();
            var tmp1_confirmationTheme = DangerButtonSemantic_getInstance();
            tmp.zgd(new (GenericConfirmationDialog())('Cancel Project?', mainMessage, VOID, 'Cancel Project', VOID, tmp1_confirmationTheme, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda$slambda_0(this.ggk_1, this.hgk_1)));
            break;
          case 1:
            var tmp_0 = get_dialogStack();
            var tmp2_confirmationTheme = DangerButtonSemantic_getInstance();
            tmp_0.zgd(new (GenericConfirmationDialog())('Cancel Project?', 'Canceling a project delays your project and impacts the contractor who has invested into this project thus far. Reasons for cancellation should be serious, such as lack of professionalism or communication by the contractor; or a client experiencing significant life changes or income loss.', VOID, 'Cancel Project', VOID, tmp2_confirmationTheme, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda$slambda_2(this.ggk_1, this.hgk_1)));
            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass = $;
  }
  return actionBar2$lambda$lambda$slambdaClass;
}
function actionBar2$lambda$lambda$slambda_0($this_actionBar2, $this_remember, $project) {
  var i = new (actionBar2$lambda$lambda$slambda())($this_actionBar2, $this_remember, $project);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (confirmed) {
    var session = $this.igk_1.daj(get_session());
    var tmp = session.vfw().rfg_1.bfp($this.jgk_1.v7a_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    get_mainPageNavigator($this.kgk_1).sd6();
  }
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambda$slambdaClass_1;
function actionBar2$lambda$lambda$slambda$slambda_3() {
  if (actionBar2$lambda$lambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($this_remember, $project, $$this$with) {
        this.igk_1 = $this_remember;
        this.jgk_1 = $project;
        this.kgk_1 = $$this$with;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambda$slambdaClass_1 = $;
  }
  return actionBar2$lambda$lambda$slambda$slambdaClass_1;
}
function actionBar2$lambda$lambda$slambda$slambda_4($this_remember, $project, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda$slambda_3())($this_remember, $project, $$this$with);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_0;
function actionBar2$lambda$lambda$slambda_1() {
  if (actionBar2$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_remember, $project, $$this$with) {
        this.lgk_1 = $this_remember;
        this.mgk_1 = $project;
        this.ngk_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp0_confirmationTheme = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Abandon Project?', 'Abandoning this project will notify the client. Ensure you clearly communicate your reasons for this action. The project will be archived and shared links will no longer work.', VOID, 'Abandon Project', VOID, tmp0_confirmationTheme, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda$slambda_4(this.lgk_1, this.mgk_1, this.ngk_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_0 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_0;
}
function actionBar2$lambda$lambda$slambda_2($this_remember, $project, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda_1())($this_remember, $project, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  if (it) {
    var id = $this.ogk_1.lf8();
    var session = $this.pgk_1.daj(get_session());
    var tmp = session.vfw().rfg_1.dfp(id, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var updated = tmp;
    var tmp_0 = (it) => it.v7a_1.equals(id);
    session.rfv_1.eeo(tmp_0, (it) => updated);
    get_mainPageNavigator($this.qgk_1).pd6(new (EditProject())(id));
  }
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambda$slambdaClass_2;
function actionBar2$lambda$lambda$slambda$slambda_5() {
  if (actionBar2$lambda$lambda$slambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_actionBar2, $this_remember, $$this$with) {
        this.ogk_1 = $this_actionBar2;
        this.pgk_1 = $this_remember;
        this.qgk_1 = $$this$with;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambda$slambdaClass_2 = $;
  }
  return actionBar2$lambda$lambda$slambda$slambdaClass_2;
}
function actionBar2$lambda$lambda$slambda$slambda_6($this_actionBar2, $this_remember, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda$slambda_5())($this_actionBar2, $this_remember, $$this$with);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_1;
function actionBar2$lambda$lambda$slambda_3() {
  if (actionBar2$lambda$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($this_actionBar2, $this_remember, $$this$with) {
        this.rgk_1 = $this_actionBar2;
        this.sgk_1 = $this_remember;
        this.tgk_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Unpublish Project?', 'You are about to unpublish this project. Though it may be viewable, the customer will no longer be able to accept the project. Are you sure?', VOID, 'Unpublish Project', VOID, tmp_0, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda$slambda_6(this.rgk_1, this.sgk_1, this.tgk_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_1 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_1;
}
function actionBar2$lambda$lambda$slambda_4($this_actionBar2, $this_remember, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda_3())($this_actionBar2, $this_remember, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var email = $this.ugk_1.daj($this.vgk_1);
  var tmp = $this.ugk_1.daj(get_session()).vfw().rfg_1.ffp($this.wgk_1.lf8(), new (EmailAddressWithName())(toEmailAddress(email), $this.ugk_1.daj($this.wgk_1.ygk()).d5c_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xgk_1();
  return Unit_instance;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var actionBar2$lambda$lambda$slambda$lambda$slambdaClass;
function actionBar2$lambda$lambda$slambda$lambda$slambda() {
  if (actionBar2$lambda$lambda$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($this_remember, $email, $this_actionBar2, $close) {
        this.ugk_1 = $this_remember;
        this.vgk_1 = $email;
        this.wgk_1 = $this_actionBar2;
        this.xgk_1 = $close;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actionBar2$lambda$lambda$slambda$lambda$slambdaClass = $;
  }
  return actionBar2$lambda$lambda$slambda$lambda$slambdaClass;
}
function actionBar2$lambda$lambda$slambda$lambda$slambda_0($this_remember, $email, $this_actionBar2, $close) {
  var i = new (actionBar2$lambda$lambda$slambda$lambda$slambda())($this_remember, $email, $this_actionBar2, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var actionBar2$lambda$lambda$slambda$lambda$slambdaClass_0;
function actionBar2$lambda$lambda$slambda$lambda$slambda_1() {
  if (actionBar2$lambda$lambda$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.zgk_1 = $close;
      }
      uao($completion) {
        this.zgk_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actionBar2$lambda$lambda$slambda$lambda$slambdaClass_0 = $;
  }
  return actionBar2$lambda$lambda$slambda$lambda$slambdaClass_0;
}
function actionBar2$lambda$lambda$slambda$lambda$slambda_2($close) {
  var i = new (actionBar2$lambda$lambda$slambda$lambda$slambda_1())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_2;
function actionBar2$lambda$lambda$slambda_5() {
  if (actionBar2$lambda$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($$this$with, $this_actionBar2, $this_remember) {
        this.agl_1 = $$this$with;
        this.bgl_1 = $this_actionBar2;
        this.cgl_1 = $this_remember;
      }
      yah($this$ButtonAction, $completion) {
        dialog(this.agl_1, VOID, ($this$dialog, close) => {
          var email = assertValidEmail(validated(mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.daj(this.bgl_1.ygk()).g5c_1)));
          var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(25));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.gbb(p, view);
          view.zbm(true);
          title(view, 'Email Invite Link');
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          view_0.bb9(get_AppDimensions().pg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_AppDimensions().rg2_1);
          view_1.lbb(get_centered(view_1), bodyBold(view_1, 'Email'));
          view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
          view_0.hbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_0 = view_0.jbb(FieldSemantic_getInstance());
          var tmp_1 = validate(view_0, email);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextInput())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          view_2.zah(view_2.icn_1, email);
          view_0.hbb(p_2, view_2);
          view_0.lbb(tmp_1, view_2);
          var tmp$ret$8 = issueText(view_0, get_issues(email));
          view_0.lbb(tmp_0, tmp$ret$8);
          view.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Space())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          view.hbb(p_3, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_4 = view.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
          view.gbb(p_4, view_4);
          view_4.zbm(false);
          var tmp_2 = get_primaryButton(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Button())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.gbb(p_5, view_5);
          var tmp_3 = KMutableProperty0();
          var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_5);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_5));
          reactiveScope(view_5, ($this$reactiveScope) => {
            var tmp$ret$17 = $this$reactiveScope.daj(get_issues(email)).i1();
            this_0.set(tmp$ret$17);
            return Unit_instance;
          });
          specCenteredText(view_5, 'Send Email');
          onClick(view_5, VOID, VOID, actionBar2$lambda$lambda$slambda$lambda$slambda_0(this.cgl_1, email, this.bgl_1, close));
          view_4.hbb(p_5, view_5);
          view_4.lbb(tmp_2, view_5);
          var tmp_5 = get_textButton(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Button())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_6, view_6);
          specCenteredText(view_6, 'Go Back');
          onClick(view_6, VOID, VOID, actionBar2$lambda$lambda$slambda$lambda$slambda_2(close));
          view_4.hbb(p_6, view_6);
          view_4.lbb(tmp_5, view_6);
          view.hbb(p_4, view_4);
          $this$dialog.hbb(p, view);
          $this$dialog.lbb(tmp, view);
          return Unit_instance;
        });
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_2 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_2;
}
function actionBar2$lambda$lambda$slambda_6($$this$with, $this_actionBar2, $this_remember) {
  var i = new (actionBar2$lambda$lambda$slambda_5())($$this$with, $this_actionBar2, $this_remember);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$ButtonAction, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = RequestFinalCompletionDialog($this.dgl_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.zgd(tmp_0);
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_3;
function actionBar2$lambda$lambda$slambda_7() {
  if (actionBar2$lambda$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($this_actionBar2) {
        this.dgl_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_3 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_3;
}
function actionBar2$lambda$lambda$slambda_8($this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_7())($this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $this$ButtonAction, $completion) {
  var tmp0_elvis_lhs = $this.fgl_1.s7b_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp_0 = tmp;
  var tmp_1 = $this.ggl_1.tgj();
  var tmp_2 = awaitSuspending($this.ggl_1.ygk(), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = awaitSuspending($this.ggl_1.hgl(), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  navigateOrDialog($this.egl_1, new (ProjectCompleteRequestDetails())($this.fgl_1, tmp_0, tmp_1, tmp_2.d5c_1, tmp_3.v5i_1, $this.ggl_1));
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_4;
function actionBar2$lambda$lambda$slambda_9() {
  if (actionBar2$lambda$lambda$slambdaClass_4 === VOID) {
    class $ {
      constructor($$this$with, $project, $this_actionBar2) {
        this.egl_1 = $$this$with;
        this.fgl_1 = $project;
        this.ggl_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_4 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_4;
}
function actionBar2$lambda$lambda$slambda_10($$this$with, $project, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_9())($$this$with, $project, $this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $this$ButtonAction, $completion) {
  var info = new (ClientPaymentInfo())($this.igl_1.lf8());
  var tmp = info.ngl($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  get_dialogStack().zgd(new (CollectFundsThroughPhysicalCheckDialog())($this.jgl_1.daj(info.lgl_1).p9v_1, new (ClientPaymentInfo())($this.igl_1.lf8())));
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_5;
function actionBar2$lambda$lambda$slambda_11() {
  if (actionBar2$lambda$lambda$slambdaClass_5 === VOID) {
    class $ {
      constructor($this_actionBar2, $this_remember) {
        this.igl_1 = $this_actionBar2;
        this.jgl_1 = $this_remember;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_5 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_5;
}
function actionBar2$lambda$lambda$slambda_12($this_actionBar2, $this_remember) {
  var i = new (actionBar2$lambda$lambda$slambda_11())($this_actionBar2, $this_remember);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.ogl_1.daj($this.pgl_1.vgj());
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.j61_1 === Companion_instance.m62(0) && element.i61_1 === Companion_instance.m62(0)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp = $this.ogl_1.daj(get_session()).qfw_1.geo(element_0.d61_1).kem($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambda$slambdaClass_3;
function actionBar2$lambda$lambda$slambda$slambda_7() {
  if (actionBar2$lambda$lambda$slambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($this_remember, $this_actionBar2) {
        this.ogl_1 = $this_remember;
        this.pgl_1 = $this_actionBar2;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actionBar2$lambda$lambda$slambda$slambdaClass_3 = $;
  }
  return actionBar2$lambda$lambda$slambda$slambdaClass_3;
}
function actionBar2$lambda$lambda$slambda$slambda_8($this_remember, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda$slambda_7())($this_remember, $this_actionBar2);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_6;
function actionBar2$lambda$lambda$slambda_13() {
  if (actionBar2$lambda$lambda$slambdaClass_6 === VOID) {
    class $ {
      constructor($$this$with, $this_remember, $this_actionBar2) {
        this.qgl_1 = $$this$with;
        this.rgl_1 = $this_remember;
        this.sgl_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = DangerButtonSemantic_getInstance();
        confirmationDialog(this.qgl_1, 'Rescind Funds Request?', 'You are about to cancel your request for funds. Make sure to communicate with your client why you are taking this action to prevent confusion.', 'Rescind Funds Request', VOID, tmp, VOID, VOID, VOID, VOID, actionBar2$lambda$lambda$slambda$slambda_8(this.rgl_1, this.sgl_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_6 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_6;
}
function actionBar2$lambda$lambda$slambda_14($$this$with, $this_remember, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_13())($$this$with, $this_remember, $this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $this$ButtonAction, $completion) {
  var tmp = get_dialogStack();
  var tmp_0;
  var tmp_1 = awaitSuspending($this.ugl_1.jgi_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (tmp_1) {
    var tmp_2 = awaitSuspending($this.ugl_1.vgj(), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = tmp_2;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.k61_1 == null) {
        destination.v(element);
      }
    }
    tmp_0 = new (PayRequested())(destination);
  } else {
    tmp_0 = PayUnrequested_getInstance();
  }
  tmp.fbw(new (MakePaymentInfoBandaidDialog())($this.tgl_1, tmp_0));
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_7;
function actionBar2$lambda$lambda$slambda_15() {
  if (actionBar2$lambda$lambda$slambdaClass_7 === VOID) {
    class $ {
      constructor($project, $this_actionBar2) {
        this.tgl_1 = $project;
        this.ugl_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_7 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_7;
}
function actionBar2$lambda$lambda$slambda_16($project, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_15())($project, $this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $this$ButtonAction, $completion) {
  var tmp = $this.vgl_1.xgl($this.wgl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_8;
function actionBar2$lambda$lambda$slambda_17() {
  if (actionBar2$lambda$lambda$slambdaClass_8 === VOID) {
    class $ {
      constructor($this_actionBar2, $$this$with) {
        this.vgl_1 = $this_actionBar2;
        this.wgl_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_8 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_8;
}
function actionBar2$lambda$lambda$slambda_18($this_actionBar2, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda_17())($this_actionBar2, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_9;
function actionBar2$lambda$lambda$slambda_19() {
  if (actionBar2$lambda$lambda$slambdaClass_9 === VOID) {
    class $ {
      constructor($project, $this_actionBar2) {
        this.ygl_1 = $project;
        this.zgl_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        get_dialogStack().zgd(new (UploadSettlementDocsDialog())(this.ygl_1, this.zgl_1.tgj(), this.zgl_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_9 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_9;
}
function actionBar2$lambda$lambda$slambda_20($project, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_19())($project, $this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_10;
function actionBar2$lambda$lambda$slambda_21() {
  if (actionBar2$lambda$lambda$slambdaClass_10 === VOID) {
    class $ {
      constructor($this_remember, $this_actionBar2) {
        this.agm_1 = $this_remember;
        this.bgm_1 = $this_actionBar2;
      }
      yah($this$rememberSuspending, $completion) {
        return this.agm_1.daj(get_session()).vfw().rfg_1.efp(this.bgm_1.lf8(), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_10 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_10;
}
function actionBar2$lambda$lambda$slambda_22($this_remember, $this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_21())($this_remember, $this_actionBar2);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $this$ButtonAction, $completion) {
  var tmp = $this.cgm_1.pc();
  var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp($this.dgm_1.sah());
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp_1 = awaitSuspending($this.dgm_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  setClipboardText(tmp, tmp_0);
  toast($this.cgm_1, VOID, actionBar2$lambda$lambda$slambda$lambda);
  return Unit_instance;
}
function actionBar2$lambda$lambda$slambda$lambda($this$toast) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$toast.pc());
  var tmp0_elvis_lhs = $this$toast.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$toast : tmp0_elvis_lhs;
  $this$toast.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
  view.gba(get_rem(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Project Link Copied';
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.hbu(tmp_0);
  $this$toast.hbb(p, view);
  return view;
}
var actionBar2$lambda$lambda$slambdaClass_11;
function actionBar2$lambda$lambda$slambda_23() {
  if (actionBar2$lambda$lambda$slambdaClass_11 === VOID) {
    class $ {
      constructor($$this$with, $link) {
        this.cgm_1 = $$this$with;
        this.dgm_1 = $link;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_11 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_11;
}
function actionBar2$lambda$lambda$slambda_24($$this$with, $link) {
  var i = new (actionBar2$lambda$lambda$slambda_23())($$this$with, $link);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_12;
function actionBar2$lambda$lambda$slambda_25() {
  if (actionBar2$lambda$lambda$slambdaClass_12 === VOID) {
    class $ {
      constructor($this_actionBar2) {
        this.egm_1 = $this_actionBar2;
      }
      yah($this$ButtonAction, $completion) {
        get_dialogStack().zgd(ProjectUnlockProposalDialog(this.egm_1.tgj(), this.egm_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_12 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_12;
}
function actionBar2$lambda$lambda$slambda_26($this_actionBar2) {
  var i = new (actionBar2$lambda$lambda$slambda_25())($this_actionBar2);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_13;
function actionBar2$lambda$lambda$slambda_27() {
  if (actionBar2$lambda$lambda$slambdaClass_13 === VOID) {
    class $ {
      constructor($this_actionBar2, $$this$with, $mostRecentRequest, $submittedByMe) {
        this.fgm_1 = $this_actionBar2;
        this.ggm_1 = $$this$with;
        this.hgm_1 = $mostRecentRequest;
        this.igm_1 = $submittedByMe;
      }
      yah($this$ButtonAction, $completion) {
        viewUnlockProposalDialog(this.fgm_1, this.ggm_1, this.hgm_1, this.igm_1, this.fgm_1.tgj());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_13 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_13;
}
function actionBar2$lambda$lambda$slambda_28($this_actionBar2, $$this$with, $mostRecentRequest, $submittedByMe) {
  var i = new (actionBar2$lambda$lambda$slambda_27())($this_actionBar2, $$this$with, $mostRecentRequest, $submittedByMe);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var actionBar2$lambda$lambda$slambdaClass_14;
function actionBar2$lambda$lambda$slambda_29() {
  if (actionBar2$lambda$lambda$slambdaClass_14 === VOID) {
    class $ {
      constructor($this_actionBar2, $this_remember) {
        this.jgm_1 = $this_actionBar2;
        this.kgm_1 = $this_remember;
      }
      yah($this$ButtonAction, $completion) {
        requestFundsDialog(this.jgm_1, this.kgm_1.daj(this.jgm_1.lfy()));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_14 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_14;
}
function actionBar2$lambda$lambda$slambda_30($this_actionBar2, $this_remember) {
  var i = new (actionBar2$lambda$lambda$slambda_29())($this_actionBar2, $this_remember);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $this$ButtonAction, $completion) {
  var tmp = awaitSuspending($this.lgm_1.lfy(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var project = tmp;
  var tmp0_elvis_lhs = project.s7b_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_1 = tmp_0;
  var tmp_2 = $this.lgm_1.tgj();
  var tmp_3 = awaitSuspending($this.lgm_1.ygk(), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = awaitSuspending($this.lgm_1.hgl(), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  navigateOrDialog($this.mgm_1, new (ProjectCompleteRequestDetails())(project, tmp_1, tmp_2, tmp_3.d5c_1, tmp_4.v5i_1, $this.lgm_1));
  return Unit_instance;
}
var actionBar2$lambda$lambda$slambdaClass_15;
function actionBar2$lambda$lambda$slambda_31() {
  if (actionBar2$lambda$lambda$slambdaClass_15 === VOID) {
    class $ {
      constructor($this_actionBar2, $$this$with) {
        this.lgm_1 = $this_actionBar2;
        this.mgm_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$lambda$slambdaClass_15 = $;
  }
  return actionBar2$lambda$lambda$slambdaClass_15;
}
function actionBar2$lambda$lambda$slambda_32($this_actionBar2, $$this$with) {
  var i = new (actionBar2$lambda$lambda$slambda_31())($this_actionBar2, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, $this$Action, $completion) {
  var tmp = $this.ngm_1.pgm($this.ogm_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var actionBar2$lambda$slambdaClass;
function actionBar2$lambda$slambda() {
  if (actionBar2$lambda$slambdaClass === VOID) {
    class $ {
      constructor($this_actionBar2, $$this$button) {
        this.ngm_1 = $this_actionBar2;
        this.ogm_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$slambdaClass = $;
  }
  return actionBar2$lambda$slambdaClass;
}
function actionBar2$lambda$slambda_0($this_actionBar2, $$this$button) {
  var i = new (actionBar2$lambda$slambda())($this_actionBar2, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $this$Action, $completion) {
  var tmp = $this.qgm_1.sgm($this.rgm_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var actionBar2$lambda$slambdaClass_0;
function actionBar2$lambda$slambda_1() {
  if (actionBar2$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_actionBar2, $$this$button) {
        this.qgm_1 = $this_actionBar2;
        this.rgm_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    actionBar2$lambda$slambdaClass_0 = $;
  }
  return actionBar2$lambda$slambdaClass_0;
}
function actionBar2$lambda$slambda_2($this_actionBar2, $$this$button) {
  var i = new (actionBar2$lambda$slambda_1())($this_actionBar2, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = awaitSuspending($this.tgm_1.vgm(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var l = tmp_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(l, 10));
  var _iterator__ex2g4s = l.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.jf9_1;
    destination.v(tmp$ret$1);
  }
  var workItems = toSet(destination);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = l.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var list = element.lf9_1;
    addAll(destination_0, list);
  }
  var itemChanges = toSet(destination_0);
  var tmp_1 = awaitSuspending($this.tgm_1.wgm(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var punchLists = toSet(tmp_1);
  var tmp_2 = session.vfw().rfg_1.lfp($this.tgm_1.lf8(), hash($this.ugm_1, workItems, itemChanges, punchLists), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = delay(200n, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
  var tmp$ret$8 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$8);
  var tmp$ret$10 = and(and(eq(get_project(it), $this.tgm_1.lf8()), eq(get_party(it), Party_Client_getInstance())), eq(get_state(it), PaymentState_AwaitingConfirmation_getInstance()));
  var tmp$ret$11 = new (Query())(tmp$ret$10, orderBy, 0, 100);
  var tmp_5 = session.sfv_1.tdv_1.cek(tmp$ret$11, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var this_1 = tmp_5;
  var sum = Companion_instance.r91(0n);
  var _iterator__ex2g4s_1 = this_1.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_0 = _iterator__ex2g4s_1.o1();
    var tmp_6 = sum;
    var tmp$ret$12 = element_0.s7k_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp_6, tmp$ret$12);
  }
  var tmp$ret$13 = sum;
  var pendingRefunds = _MonetaryValue___get_absoluteValue__impl__hjldkw(tmp$ret$13);
  if (MonetaryValue__compareTo_impl_w7ul1r(pendingRefunds, Companion_instance.r91(0n)) > 0) {
    var tmp_7 = get_dialogStack();
    // Inline function 'kotlin.apply' call
    var this_2 = new (ClientPaymentInfo())($this.tgm_1.lf8());
    var tmp_8 = this_2.ngl($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    tmp_7.zgd(new (CollectFundsThroughPhysicalCheckDialog())(pendingRefunds, this_2));
  } else {
    get_dialogStack().wgg();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $this$ButtonAction, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xgm_1.lfy();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var project = tmp;
  var tmp_0 = awaitSuspending($this.xgm_1.hgi_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (!tmp_0) {
    dialog($this.ygm_1, VOID, ($this$dialog, close) => {
      var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(30));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$dialog.pc());
      var tmp0_elvis_lhs = $this$dialog.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
      $this$dialog.gbb(p, view);
      view.zbm(true);
      title(view, 'Funding Needed');
      body(view, 'You cannot accept the project as complete until all funding has been provided. Please deposit the remaining funds and try again.');
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      view_0.zbm(false);
      var tmp_0 = get_primaryButton(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      specCenteredText(view_1, 'Deposit Funds');
      onClick(view_1, 'Deposit Funds', VOID, acceptFinalCompletion$slambda$lambda$slambda_0(project, close));
      view_0.hbb(p_1, view_1);
      view_0.lbb(tmp_0, view_1);
      var tmp_1 = get_textButton(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.gbb(p_2, view_2);
      specCenteredText(view_2, 'Go Back');
      onClick(view_2, VOID, VOID, acceptFinalCompletion$slambda$lambda$slambda_2(close));
      view_0.hbb(p_2, view_2);
      view_0.lbb(tmp_1, view_2);
      view.hbb(p_0, view_0);
      $this$dialog.hbb(p, view);
      $this$dialog.lbb(tmp, view);
      return Unit_instance;
    });
  } else {
    var tmp_1 = !(project.h7b_1 == null) ? 'Accept & Pay Retention' : 'Accept Project Completion';
    var tmp_2 = PrimaryButtonSemantic_getInstance();
    confirmationDialog($this.ygm_1, 'Finalize and Complete Project?', 'By approving this project:\n\nYou confirm that all work, including punch list items, has been completed to your satisfaction.\nRetention funds (if applicable) will be released to the contractor.\nThe project will be marked as complete in Stoze, concluding the agreement.\n\nFor minor concerns or adjustments, the warranty phase is available to address them after completion. If you have unresolved major concerns, do not proceed. Use Stoze\u2019s messaging to communicate with your contractor before finalizing.', tmp_1, VOID, tmp_2, VOID, false, 'PROJECT SIGN-OFF', VOID, acceptFinalCompletion$slambda$slambda_0($this.xgm_1, project));
  }
  return Unit_instance;
}
var acceptFinalCompletion$slambda$lambda$slambdaClass;
function acceptFinalCompletion$slambda$lambda$slambda() {
  if (acceptFinalCompletion$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($project, $close) {
        this.zgm_1 = $project;
        this.agn_1 = $close;
      }
      uao($completion) {
        get_dialogStack().pd6(new (MakePaymentInfoBandaidDialog())(this.zgm_1, PayRemainingToCompleteProject_getInstance()));
        this.agn_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    acceptFinalCompletion$slambda$lambda$slambdaClass = $;
  }
  return acceptFinalCompletion$slambda$lambda$slambdaClass;
}
function acceptFinalCompletion$slambda$lambda$slambda_0($project, $close) {
  var i = new (acceptFinalCompletion$slambda$lambda$slambda())($project, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var acceptFinalCompletion$slambda$lambda$slambdaClass_0;
function acceptFinalCompletion$slambda$lambda$slambda_1() {
  if (acceptFinalCompletion$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.bgn_1 = $close;
      }
      uao($completion) {
        this.bgn_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    acceptFinalCompletion$slambda$lambda$slambdaClass_0 = $;
  }
  return acceptFinalCompletion$slambda$lambda$slambdaClass_0;
}
function acceptFinalCompletion$slambda$lambda$slambda_2($close) {
  var i = new (acceptFinalCompletion$slambda$lambda$slambda_1())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var acceptFinalCompletion$slambda$slambdaClass;
function acceptFinalCompletion$slambda$slambda() {
  if (acceptFinalCompletion$slambda$slambdaClass === VOID) {
    class $ {
      constructor($projectData, $project) {
        this.tgm_1 = $projectData;
        this.ugm_1 = $project;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    acceptFinalCompletion$slambda$slambdaClass = $;
  }
  return acceptFinalCompletion$slambda$slambdaClass;
}
function acceptFinalCompletion$slambda$slambda_0($projectData, $project) {
  var i = new (acceptFinalCompletion$slambda$slambda())($projectData, $project);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var acceptFinalCompletion$slambdaClass;
function acceptFinalCompletion$slambda() {
  if (acceptFinalCompletion$slambdaClass === VOID) {
    class $ {
      constructor($projectData, $$this$with) {
        this.xgm_1 = $projectData;
        this.ygm_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    acceptFinalCompletion$slambdaClass = $;
  }
  return acceptFinalCompletion$slambdaClass;
}
function acceptFinalCompletion$slambda_0($projectData, $$this$with) {
  var i = new (acceptFinalCompletion$slambda())($projectData, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function raiseIssueAtFinalCompletion$slambda$lambda($this$FileIncidentConfirmation) {
  $this$FileIncidentConfirmation.rgn_1.oam(true);
  return Unit_instance;
}
var raiseIssueAtFinalCompletion$slambdaClass;
function raiseIssueAtFinalCompletion$slambda() {
  if (raiseIssueAtFinalCompletion$slambdaClass === VOID) {
    class $ {
      constructor($project, $lens) {
        this.dgo_1 = $project;
        this.ego_1 = $lens;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = ButtonFormatting('Raise Issue', IssueButton_getInstance());
        tmp.zgd(new (FileIncidentConfirmation())(this.dgo_1, this.ego_1, 'Raise Issue?', "Raising an issue at this stage of the project should only be done if there's a serious issue that needs to be addressed.\n \nIf your concerns are minor, consider just messaging the contractor instead of filing an issue.", 'File an issue if your concern is serious and is worth withholding project completion and final payment.\n\nSend a message if your concern is minor or if you just need clarification on project completion.', tmp_0, raiseIssueAtFinalCompletion$slambda$lambda));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    raiseIssueAtFinalCompletion$slambdaClass = $;
  }
  return raiseIssueAtFinalCompletion$slambdaClass;
}
function raiseIssueAtFinalCompletion$slambda_0($project, $lens) {
  var i = new (raiseIssueAtFinalCompletion$slambda())($project, $lens);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  acceptFinalCompletion as acceptFinalCompletion1zm28w35ed7aq,
  actionBar2 as actionBar2229z9n90psciq,
  raiseIssueAtFinalCompletion as raiseIssueAtFinalCompletionodlw1oct00lk,
};
//endregion

//# sourceMappingURL=actionBar.mjs.map
